import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useInvalidateHomeState } from '../../home/hooks/use-home-state'
import { outreachApi, outreachStatusQueryKey } from '../api'

export function useDisableOutreachMutation(startupId: string) {
  const queryClient = useQueryClient()
  // See useEnableOutreachMutation — pausing moves Home's state just as much as
  // resuming does.
  const invalidateHome = useInvalidateHomeState(startupId)
  return useMutation({
    mutationFn: () => outreachApi.disable(startupId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: outreachStatusQueryKey(startupId) })
      await invalidateHome()
    },
  })
}
